module.exports = __webpack_public_path__ + "static/media/touran.24c3c945.png";